import { render, staticRenderFns } from "./VcardContent.vue?vue&type=template&id=5a78ce0d&scoped=true&"
import script from "./VcardContent.vue?vue&type=script&lang=js&"
export * from "./VcardContent.vue?vue&type=script&lang=js&"
import style0 from "./VcardContent.vue?vue&type=style&index=0&id=5a78ce0d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78ce0d",
  null
  
)

export default component.exports